export const getPanosInstallCommand = (
  tokenValue: string,
) => `export MONDOO_REGISTRATION_TOKEN='${tokenValue}'
curl -sSL https://install.mondoo.com/sh | bash -s -- -t $MONDOO_REGISTRATION_TOKEN`;
